import { createSlice } from "@reduxjs/toolkit";

const initialFaspayState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  totalPrice: 0,
  totalCountReseller: 0,
  totalPriceReseller: 0,
  totalFeeReseller: 0,
  generateNum: "",
  entities: null,
  meta: { total: 0 },
  links: null,
  currency: "IDR",
  total_price: null,
  lastError: null,
  faspayForEdit: undefined,
  faspayForExport: [],
  faspayForExportSummary: [],
  faspayForGenerateMitra: [],
  faspayForGenerateMitraReseller: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const faspaySlice = createSlice({
  name: "faspay",
  initialState: initialFaspayState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    faspayFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    getAggregationFaspay: (state, action) => {
      const { entity } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.totalPrice = entity.total_price;
      state.error = null;
    },
    faspayCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.faspay.push(action.payload.faspay);
    },
    faspayDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.faspay.filter(
        (el) => el.faspay_id !== action.payload.id
      );
    },
    getFaspay: (state, action) => {
      state.actionsLoading = false;
      state.faspayForEdit = action.payload.faspayForEdit;
      state.error = null;
    },
    getExportFaspay: (state, action) => {
      state.actionsLoading = false;
      if (action.payload.faspayForExport === undefined) {
        state.faspayForExport = [];
      } else {
        state.faspayForExport.push(action.payload.faspayForExport);
      }
      state.error = null;
    },
    // updateProduct
    faspayUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.faspay = state.entities.faspay.map((entity) => {
        if (entity.faspay_id === action.payload.faspay.faspay_id) {
          return action.payload.faspay;
        }
        return entity;
      });
    },
    exportFetchedFaspay: (state, action) => {
      const { totalCount, export_data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.export_data = export_data;
      state.totalCount = totalCount;
    },
    exportFetchedFaspaySummary: (state, action) => {
      const { totalCount, export_data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.faspayForExportSummary = export_data;
      state.totalCount = totalCount;
    },
    exportFaspayGenerateMitra: (state, action) => {
      const {
        totalCount,
        export_data,
        total_price,
        totalCountReseller,
        export_data_reseller,
        total_price_reseller,
        total_fee_reseller,
        generatenum,
      } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.faspayForGenerateMitra = export_data;
      state.totalCount = totalCount;
      state.totalPrice = total_price;
      state.faspayForGenerateMitraReseller = export_data_reseller;
      state.totalCountReseller = totalCountReseller;
      state.totalPriceReseller = total_price_reseller;
      state.totalFeeReseller = total_fee_reseller;
      state.generateNum = generatenum;
    },
  },
});
